import Image from 'next/image';
import Link from 'next/link';

interface CardStaticProps {
  imgSrc: string;
  href: string;
}

export default function CardStatic({ imgSrc, href }: CardStaticProps) {
  return (
    //make a div containing a image with max-w-2xl rounded-br-3xl with 592x270 aspect ratio
    <div className="relative rounded-br-3xl aspect-ratio-[592/270] h-64 overflow-hidden cursor-pointer">
      <Link href={href} className="block w-full h-full">
        <Image
          src={imgSrc}
          alt="Imagem do Card"
          objectFit="cover"
          layout="fill"
        />
      </Link>
    </div>
  );
}
